import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { SectionHeadline } from '@/components/SectionHeadline';
import { InfoBoxes } from '@/components/boxes';
import React from 'react';
import IconPay from '@/assets/icons/heroIcons/Pay.svg';
import IconUserGroup from '@/assets/icons/heroIcons/User-group.svg';
import IconDumplingHappy from '@/assets/icons/heroIcons/DumplingHappy.svg';
export function HowToRecommend() {
  const $ = _c(36);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["referral"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("howToRecommend.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="mb-10 lg:mb-16" anchorKey="howToRecommend.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("howToRecommend.items.1.title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("howToRecommend.items.1.text");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IconPay />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t4) {
    t6 = {
      title: t3,
      paragraph: t4,
      icon: t5
    };
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("howToRecommend.items.2.title");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("howToRecommend.items.2.text");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <IconUserGroup />;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t7 || $[19] !== t8) {
    t10 = {
      title: t7,
      paragraph: t8,
      icon: t9
    };
    $[18] = t7;
    $[19] = t8;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t("howToRecommend.items.3.title");
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t) {
    t12 = t("howToRecommend.items.3.text");
    $[23] = t;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <IconDumplingHappy />;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t11 || $[27] !== t12) {
    t14 = {
      title: t11,
      paragraph: t12,
      icon: t13
    };
    $[26] = t11;
    $[27] = t12;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t10 || $[30] !== t14 || $[31] !== t6) {
    t15 = <div><InfoBoxes items={[t6, t10, t14]} variant="basic" /></div>;
    $[29] = t10;
    $[30] = t14;
    $[31] = t6;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t15 || $[34] !== t2) {
    t16 = <div className="px-4">{t2}{t15}</div>;
    $[33] = t15;
    $[34] = t2;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
}